module.exports = __webpack_public_path__ + "img/symbol_12.5f2469d3.png";